import React, { createContext } from 'react';

const ImageViewerContext = createContext();

export default ImageViewerContext;